import React from 'react'
import Link from 'next/link'
import {
    getSearchResultDisplayPrice,
    getSearchResultFilterKey,
} from '@/components/Refresh/SearchResults/searchResultsUtils'
import { STORE_DISPLAY_PRICE_UNAVAILABLE_LABEL } from '@/lib/store/storeDisplayPricing'
import type { ServiceItem } from '@/types/interfaces/service-item'
import ServiceImage from './ServiceImage'
import classes from './ServiceTile.module.css'

interface ServiceTileProps {
    service: ServiceItem
}

function getSkuHref(service: ServiceItem) {
    if (!service.skuName || !service.skuId) return null
    return `/s/${service.skuName}/${service.skuId}`
}

export default function ServiceTile({ service }: ServiceTileProps) {
    const href = getSkuHref(service)
    const pricedDisplay = getSearchResultDisplayPrice(service)
    const displayPrice =
        pricedDisplay ||
        (getSearchResultFilterKey(service) === 'medications' ? STORE_DISPLAY_PRICE_UNAVAILABLE_LABEL : '')

    const content = (
        <>
            <ServiceImage service={service} />
            <div className={classes.text}>
                <div className={classes.title}>{service.title}</div>
                {displayPrice !== '' && <div className={classes.price}>{displayPrice}</div>}
            </div>
        </>
    )

    if (href == null) {
        return <div className={classes.tile}>{content}</div>
    }

    return (
        <Link href={href} prefetch={false} className={classes.tile}>
            {content}
        </Link>
    )
}
